<div class="container">
    <div class="row">
        <div class="col-md-12">
            <button class="other-Button-gray float-end">清除</button>
            <button class="other-Button-gray float-end me-3">刪除</button>
            <button class="other-Button-gray float-end me-3">修改</button>
            <button class="add-btn float-end me-3">新增</button>
        </div>
    </div>
    <table class="table table-hover table-striped text-center mt-3">
        <thead class="thead-dark-red">
            <tr>
                <th></th>
                <th>代碼</th>
                <th>名稱</th>
                <th>修改者</th>
                <th>修改時間</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </table>
</div>
